module.exports = __webpack_public_path__ + "static/img/pars2.01c2320a.png";